import React, { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';
//import Theme1 from './home/theme1';
import Theme2 from './home/theme2';
//import Theme3 from './home/theme3';
import { getData, getImage } from '../../helpers/indexedDbHelper';
import { Link } from 'react-router-dom';

function Index() {
  const [vars, setvars] = useState('test');

  const [menus, setMenus] = useState([]);
  useEffect(() => {
    getData('menu').then((item) => {
      const data = item.value.data.filter((item) => item.id === 254);

      setMenus(data[0].menus);
      setvars(item.value.logo);
    });
  }, []);

  const fetchImage = async (id) => {
    const imageBlob = await getImage(id);
    if (imageBlob) {
      const imageURL = URL.createObjectURL(imageBlob.blob);
      console.log('URL de la imagen:', imageURL);
      return imageURL;
    }
    return null;
  };

  const Item = ({ data }) => {
    const [image, setImage] = useState(false);
    useEffect(() => {
      fetchImage(`menu-image-${data.id}`).then((url) => {
        if (url) {
          setImage(url);
        }
      });
    }, []);

    return (
      <Link to="/test">
        <h3 style={{ color: 'white' }}>{data.name}</h3>
        <img src={image} style={{ width: 300, height: 300 }} />
      </Link>
    );
  };
  return (
    <>
      <h1
        style={{ color: 'white' }}
        onClick={() => {
          window.location.href = '/'; // Redirige al root de la página
        }}
      >
        Hi devs
      </h1>
      <div>
        {menus.map((item, key) => (
          <Item data={item} key={key} />
        ))}
      </div>
    </>
  );
}

export default Index;
